module.exports = __webpack_public_path__ + "static/img/26.2eb3590.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/26.png
// module id = VZiH
// module chunks = 0